import {makeVar} from '@apollo/client';

import {QuestionTypeEnum} from '#apollo/schema';
import {SESSION_STORAGE_KEY} from '#constant/survey';

export interface SurveyTextAnswer {
  answer: string;
  questionId: string;
  questionType: QuestionTypeEnum.ShortTextEnum;
}

export interface SurveyNumericAnswer {
  answer: number | '';
  questionId: string;
  questionType: QuestionTypeEnum.NumericEnum;
}

export interface SurveyMultipleChoiceAnswer {
  answer: string[];
  questionId: string;
  questionType: QuestionTypeEnum.MultipleChoiceEnum;
}

export type SurveyAnswer = SurveyTextAnswer | SurveyNumericAnswer | SurveyMultipleChoiceAnswer;
export type SurveySubmission = Record<string, SurveyAnswer>;
export type SurveyVar = Record<string, SurveySubmission>;

function getInitialSurveyValue() {
  try {
    if (typeof sessionStorage !== 'undefined') {
      return JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY) || '{}') || {};
    }

    return {};
  } catch (e) {
    console.error(e);
    return {};
  }
}

const surveyInitialValue: SurveyVar = getInitialSurveyValue();

export const surveyVar = makeVar<SurveyVar>(surveyInitialValue);

export const surveyWizardVars = {
  read: () => surveyVar(),
  reset: () => {
    surveyVar({});
    sessionStorage?.removeItem(SESSION_STORAGE_KEY);
  },
  update: ({surveyId, answer}: {surveyId: string; answer: SurveyAnswer}) => {
    surveyVar({
      ...surveyVar(),
      [surveyId]: {...surveyVar()?.[surveyId], [answer.questionId]: answer},
    });
  },
  persist: () => {
    sessionStorage?.setItem(SESSION_STORAGE_KEY, JSON.stringify(surveyVar()));
  },
  var: surveyVar,
};
